import React from 'react';

import { useTranslation } from 'react-i18next';

import { formatRewardName } from '@utils/quest/formatRewardName';

import { useModals } from '@shared/contexts';

import { useQueryGetMe } from '@hooks/api/user/use-query-me';
import useGetPointsIcon from '@hooks/use-get-points-icon';

import { QuestType } from '@types';

import { Button } from '@components/button';
import { ModalName } from '@components/modals';

import * as Styled from './quest.styled';

interface QuestProps {
	quest: QuestType;
}

const Quest = ({ quest }: QuestProps) => {
	const rewardName = formatRewardName(quest.rewards?.[0]?.name || '');
	const PointsIcon = useGetPointsIcon();
	const { data: user } = useQueryGetMe();
	const pmId = user?.pm_id;
	const { openModal } = useModals();
	const { t } = useTranslation('general');

	const handleStartQuest = () => {
		if (!pmId) {
			openModal(ModalName.LOGIN);
		} else {
			if (!quest?.url) {
				return;
			}
			window.open(quest?.url, '_blank');
		}
	};

	const handleMoreDetails = () => {
		openModal(ModalName.QUEST_DETAILS, { quest });
	};

	return (
		<Styled.QuestWrapper>
			<Styled.QuestImage src={quest.image || ''} />
			<Styled.QuestReward>
				{rewardName}
				{PointsIcon}
			</Styled.QuestReward>
			<Styled.Divider />
			<Styled.QuestInfo>
				<Styled.QuestName>{quest.name || ''}</Styled.QuestName>
				<Styled.QuestDescription dangerouslySetInnerHTML={{ __html: quest.description || '' }} />
			</Styled.QuestInfo>
			<Styled.QuestButtons>
				<Button color='neutral' onClick={handleMoreDetails}>
					{t('readMoreBtn')}
				</Button>
				<Button color='primary' onClick={handleStartQuest}>
					{t('begin_quest')}
				</Button>
			</Styled.QuestButtons>
		</Styled.QuestWrapper>
	);
};

export default Quest;
